<template>
  <div class="animated fadeIn">
    <!-- Start of header session -->
    <b-row>
      <b-col>
        <div class="text-capitalize my-4">
          <strong>
            <h4>
              <router-link
                :to="{ name: 'outlets_list' }"
                class="float-left mr-1 main-link"
                >{{ $t("oos.huts") }}</router-link
              >
              <span class="float-left mr-1">></span>
              <router-link
                :to="{
                  name: 'outlets_edit',
                  params: { uuid: $route.params.uuid }
                }"
                class="float-left mr-1 main-link"
              >
                {{ store.name.en }}</router-link
              >
              <span class="float-left mr-1">></span>
              <span> {{ $t("store.deals") }}</span>
            </h4>
          </strong>
        </div>
      </b-col>
    </b-row>
    <!-- End of header session -->
    <div class="main-div">
      <div class="div-tab active">
        <p class="header-tab">{{ $t("store.current") }} ({{ totalDeals }})</p>
      </div>

      <hr class="line" />
      <b-col cols="12">
        <b-row>
          <b-col>
            <p class="title deal-block">
              {{ $t("store.optional_deals") }}
            </p>
            <p class="description deal-block">
              {{ $t("store.optional_deals_description") }}
            </p>
          </b-col>
          <b-col></b-col>
          <b-col>
            <b-input-group>
              <input
                v-model="filter.optionalDealSearch"
                @keyup.enter="
                  searchDeals(
                    'optionalDeals',
                    vm.filter.optionalDealSearch,
                    optionalDeals
                  )
                "
                type="text"
                class="form-control"
                :placeholder="$t('store.search_optional_deal')"
              />

              <div class="input-group-append c-group-append">
                <span
                  v-show="filter.optionalDealSearch.length"
                  class="clear-text-search"
                  @click="filter.optionalDealSearch = ''"
                  >✕</span
                >
                <b-input-group-append class="search-block">
                  <b-btn
                    @click="
                      getAvailableDealsList(
                        'optionalDealSearch',
                        'optionalDeals'
                      )
                    "
                  >
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </div>
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>

      <table class="table scroll">
        <thead>
          <tr>
            <th class="col-status" scope="col">
              <span>{{ $t("store.status") }}</span>
            </th>
            <th class="col-name" scope="col">
              <span>{{ $t("store.name") }}</span>
            </th>
            <th class="col-sku" scope="col">
              <span>{{ $t("store.sku").toUpperCase() }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filter.optionalDeals.length == 0">
            <td class="col-status"></td>
            <td class="col-name text-center">
              {{
                isLoading
                  ? $t("store.loading_deal_items")
                  : $t("message.no_data")
              }}
            </td>
            <td class="col-sku"></td>
          </tr>
          <tr
            v-for="item in filter.optionalDeals"
            :key="`optional-${createUUID()}`"
          >
            <td class="col-status">
              <toggle-button
                :data="item"
                :isChecked="item.isShow"
                @click="changeStatus"
              ></toggle-button>
            </td>
            <td class="col-name">
              <span>{{ item.name }} - <b>{{ convertPriceValue(item.priceValue) }}</b></span>
            </td>
            <td class="col-sku">
              <span>{{ item.sku }}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <b-col class="default-block" cols="12">
        <b-row>
          <b-col>
            <p class="title deal-block">
              {{ $t("store.default_deals") }}
            </p>
            <p class="description deal-block">
              {{ $t("store.default_deals_description") }}
            </p>
          </b-col>
          <b-col></b-col>
          <b-col>
            <b-input-group>
              <input
                v-model="filter.defaultDealSearch"
                @keyup.enter="
                  vm.searchDeals(
                    'defaultDeals',
                    vm.filter.defaultDealSearch,
                    vm.defaultDealsDeals
                  )
                "
                type="text"
                class="form-control"
                :placeholder="$t('store.search_default_deal')"
              />

              <div class="input-group-append c-group-append">
                <span
                  v-show="filter.defaultDealSearch.length"
                  class="clear-text-search"
                  @click="filter.defaultDealSearch = ''"
                  >✕</span
                >
                <b-input-group-append class="search-block">
                  <b-btn
                    @click="
                      getAvailableDealsList('defaultDealSearch', 'defaultDeals')
                    "
                  >
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </div>
            </b-input-group>
          </b-col>
        </b-row>
      </b-col>
      <table class="table scroll">
        <thead>
          <tr>
            <th class="col-status">
              <span>{{ $t("store.status") }}</span>
            </th>
            <th class="col-name" scope="col">
              <span>{{ $t("store.name") }}</span>
            </th>
            <th class="col-sku" scope="col">
              <span>{{ $t("store.sku").toUpperCase() }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="filter.defaultDeals.length == 0">
            <td class="col-status"></td>
            <td class="col-name text-center">
              {{
                isLoading
                  ? $t("store.loading_deal_items")
                  : $t("message.no_data")
              }}
            </td>
            <td class="col-sku"></td>
          </tr>
          <tr
            v-for="item in filter.defaultDeals"
            :key="`default-${createUUID()}`"
          >
            <td class="col-status">
              <toggle-button
                :data="item"
                :isChecked="item.isShow"
                :isDisable="true"
                @click="changeStatus"
              ></toggle-button>
            </td>
            <td class="col-name">
              <span>{{ item.name }} - <b>{{ convertPriceValue(item.priceValue) }}</b></span>
            </td>
            <td class="col-sku">
              <span>{{ item.sku }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<style scope>
.main-div {
  padding: 31px 39px 93px 42px;
  margin-bottom: 50px;
  background: #ffffff;
}
.div-tab.active {
  width: fit-content;
  block-size: fit-content;
  border-bottom: solid;
  border-bottom-color: #038900;
}
.header-tab {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  padding-left: 10px;
  padding-right: 10px;
}
.line {
  color: #c4c4c4;
  margin-top: -2px;
  margin-bottom: 37px;
}
.title {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;
  color: #000000;
}
.description {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}
.content-list {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
}
/* .hut-link {
  font-family: "Sharp Sans Display No1";
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
}
a.hut-link {
  color: #038900 !important;
} */

.table-bordered {
  margin-top: 10px;
}

.table-bordered thead {
  background-color: #e1e6eb;
}

.table-bordered tbody {
  background-color: #f4f6f8;
}

.table-bordered th {
  border: none;
}

.table-bordered .center {
  text-align: center;
}

.col-sm-2-custom {
  flex: 0 0 12.66667%;
  margin-top: 2px;
  text-align: center;
}

.table thead th {
  border-top: 0px solid;
  border-bottom: #c4c4c4 1px solid !important;
  margin: 16px;
}
.bottom-line {
  border-top: 0px solid;
  border-bottom: #c4c4c4 1px solid !important;
}

tr:first-child td {
  border-top: 0px solid;
  border-bottom: 0px solid !important;
}

tr:last-child {
  border-top: 0px solid;
  border-bottom: #c4c4c4 1px solid !important;
}

table.scroll tbody,
table.scroll thead {
  width: auto;
  display: block;
}

tbody {
  max-height: 322px;
  overflow-y: auto;
  overflow-x: visible;
}

.col-status {
  min-width: 84px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.33333%;
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
  position: relative;
  width: 100%;
}
.col-name {
  min-width: 470px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 33.33333%;
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
  position: relative;
  width: 100%;
}
.col-sku {
  min-width: 100px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 8.33333%;
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
  position: relative;
  width: 100%;
}
.deal-block {
  margin-left: -15px;
}

.search-block {
  margin-right: -15px;
}

.default-block {
  margin-top: 50px;
}
.clear-text-search {
  position: absolute;
  right: 1rem;
  z-index: 1000;
  cursor: pointer;
  padding: 0.5rem 1rem;
}
</style>
<script>
import ToggleButton from "../../../components/Partials/ToggleButton";
let vm = null;

export default {
  name: "AvailableDealsList",
  components: {
    ToggleButton
  },
  data: function() {
    return {
      filter: {
        optionalDealSearch: "",
        defaultDealSearch: "",
        optionalDeals: [],
        defaultDeals: []
      },
      optionalDeals: [],
      defaultDeals: [],
      isLoading: true,
      totalDeals: 0,
      store: {
        id: 0,
        code: "",
        name: { en: "" },
        address: { en: "" },
        flatten: []
      },
      headers: {
        tenant: "",
        campaignName: "",
        exportPath: "",
        storeCode: "",
        locale: "en-gb"
      },
      timer: null
    };
  },
  computed: {
    convertPriceValue: function () {
      return function(priceValue) {
        const num = parseInt(priceValue)/100;
        return num.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
      }
    }
  },
  methods: {
    createUUID: function() {
      var dt = new Date().getTime();
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    },
    changeStatus: function(data) {
      const payload = {
        in: data.isChecked ? [data.priceId] : [], // list priceIds
        out: !data.isChecked ? [data.inventoryItemId] : [] // list inventoryItemIds.
      };
      vm.axios.menuOutOfStock.updateStatusAvailableDeals(
        payload,
        vm.headers,
        success => {
          vm.$toastr.success(
            vm.$t("message.update_successful"),
            vm.$t("message.success"),
            {}
          );
        },
        error => {
          if (error.errors && Array.isArray(error.errors)) {
            error.errors.forEach(element => {
              vm.$toastr.error(
                element.errorMessage,
                vm.$t("message.error"),
                {}
              );
            });
          }
        }
      );
    },
    initial: function() {
      // initial config
      const config = vm.$session.get("config");
      const manualConfig = vm._.get(config, "manual_config", {}) || {};
      const { export_path, tenant_code, campaign_name, locale } = manualConfig;

      vm.headers.tenant = tenant_code;
      vm.headers.campaignName = campaign_name;
      vm.headers.exportPath = export_path;
      vm.headers.locale = locale;
      if (vm.$route.params.uuid) {
        vm.axios.outlet.getOutletDetail(vm.$route.params.uuid, function(
          response
        ) {
          const { id, code, name, address } = vm._.get(
            response,
            "data.data.item",
            []
          );
          const flatten = code.includes("/") ? code.split("/") : [code];
          vm.store = { id, code, name, address, flatten };

          // add storeCode to header
          vm.headers.storeCode = flatten[flatten.length - 1];
          vm.getAvailableDealsList();
        });
      }
    },
    getAvailableDealsList: function(filterObjName, dealListName) {
      if (dealListName && vm._.get(vm.filter, dealListName, null)) {
        vm.filter[dealListName] = [];
      }

      vm.isLoading = true;
      vm.axios.outlet.getAvailableDealsList(
        vm.headers,
        response => {
          vm.$bus.$emit("loading", "none");
          const { national_deals, optional_deals } = vm._.get(
            response,
            "data.data.item"
          );

          const getDataItem = item => {
            const sku = vm._.get(item, "inventoryItem.skus", [])[0];
            return {
              isShow: item.isShow,
              name: vm._.get(item, "inventoryItem.title", ""),
              sku: sku && sku.code ? sku.code : "",
              priceId: item.id,
              inventoryItemId: item.inventoryItemId,
              priceValue: item.priceValue
            };
          };
          vm.optionalDeals = (optional_deals || []).map(getDataItem);
          vm.defaultDealsDeals = (national_deals || []).map(getDataItem);

          vm.totalDeals = vm.optionalDeals.length + vm.defaultDealsDeals.length;

          vm.filterDeals(
            "optionalDeals",
            vm.filter.optionalDealSearch,
            vm.optionalDeals
          );
          vm.filterDeals(
            "defaultDeals",
            vm.filter.defaultDealSearch,
            vm.defaultDealsDeals
          );

          vm.isLoading = false;
        },
        error => {
          if (error.errors && Array.isArray(error.errors)) {
            error.errors.forEach(element => {
              vm.$toastr.error(
                element.errorMessage,
                vm.$t("message.error"),
                {}
              );
            });
          }
          vm.isLoading = false;
        }
      );
    },
    filterDeals: function(dealListName, strSearch, data) {
      vm.filter[dealListName] = data.filter(
        item => item.name.toLowerCase().indexOf(strSearch.toLowerCase()) > -1
      );
    },
    searchDeals: function(dealListName, strSearch, data) {
      vm.isLoading = true;
      vm.filter[dealListName] = [];
      vm.filterDeals(dealListName, strSearch, data);
      vm.isLoading = false;
    }
  },
  created: function() {
    vm = this;
    vm.initial();
  },
  watch: {
    "filter.optionalDealSearch": function() {
      vm.searchDeals(
        "optionalDeals",
        vm.filter.optionalDealSearch,
        vm.optionalDeals
      );
    },
    "filter.defaultDealSearch": function() {
      vm.searchDeals(
        "defaultDeals",
        vm.filter.defaultDealSearch,
        vm.defaultDealsDeals
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/admin/outlets/AvailableDealsList.vue